export const GETTING_USER_DETAILS = 'GETTING_USER_DETAILS';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_ERROR = 'GET_USER_DETAILS_ERROR';
export const RESET_USER_DETAILS_STATE = 'RESET_USER_DETAILS_STATE';

export const GETTING_MONITORING_DETAILS = 'GETTING_MONITORING_DETAILS';
export const GET_MONITORING_SUCCESS = 'GET_MONITORING_SUCCESS';
export const GET_MONITORING_ERROR = 'GET_MONITORING_ERROR';
